import RestrictMesh from "../resources/restrict-mesh";

class RestrictMoveAndRotate extends RestrictMesh {
    constructor() {
        super();
    }
}

export default RestrictMoveAndRotate;